import React, { useState } from "react";
import {
  User,
  Briefcase,
  Plane,
  KeyRound,
  Headphones,
  ChevronDown,
  Pencil,
  LayoutGrid,
  Calendar,
  X,
} from "lucide-react";
import "../Content/CSS/Profilepage.css";

const navItems = [
  { key: "profile", label: "Profile", icon: User },
  {
    key: "bookings",
    label: "My Bookings",
    icon: Briefcase,
    hasChildren: true,
    children: [{ key: "flights", label: "Flight Bookings", icon: Plane }],
  },
  { key: "reset", label: "Reset Password", icon: KeyRound },
  { key: "support", label: "Support", icon: Headphones },
];

// ===================== Flight Bookings tab content =====================
function FlightBookingsContent() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [bookings, setBookings] = useState([]); // real bookings yahan set honge (API se)

  const handleFilter = () => {
    // TODO: yahan API call lagaiye jo fromDate/toDate ke hisaab se bookings fetch kare
    console.log("Filtering bookings from", fromDate, "to", toDate);
  };

  return (
    <>
      <div className="profile-main__header">
        <h1>Flight Booking Summary</h1>
      </div>

      <div className="booking-filters">
        <div className="booking-filters__field">
          <label htmlFor="fromDate">From Date</label>
          <div className="date-input-wrap">
            <Calendar size={16} />
            <input
              id="fromDate"
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
        </div>

        <div className="booking-filters__field">
          <label htmlFor="toDate">To Date</label>
          <div className="date-input-wrap">
            <Calendar size={16} />
            <input
              id="toDate"
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
        </div>

        <button
          type="button"
          className="booking-filters__btn"
          onClick={handleFilter}
        >
          FILTER NOW
        </button>
      </div>

      <div className="booking-tabs">
        <button type="button" className="booking-tabs__item active">
          ALL BOOKINGS
        </button>
      </div>

      <div className="booking-list">
        {bookings.length === 0 ? (
          <div className="booking-empty">
            <p>No bookings found.</p>
          </div>
        ) : (
          bookings.map((b) => (
            <div key={b.id} className="booking-row">
              {/* booking row content yahan render hoga jab data aayega */}
            </div>
          ))
        )}
      </div>
    </>
  );
}

// ===================== Edit Personal Information Modal =====================
function EditPersonalInfoModal({ profile, onClose, onSave }) {
  const parseFullName = (fullName) => {
    const parts = (fullName || "").trim().split(" ");
    let title = "Mr.";
    let rest = parts;

    if (["Mr", "Mr.", "Ms", "Ms.", "Mrs", "Mrs."].includes(parts[0])) {
      title = parts[0].endsWith(".") ? parts[0] : `${parts[0]}.`;
      rest = parts.slice(1);
    }

    const firstName = rest[0] || "";
    const lastName = rest.slice(1).join(" ") || "";

    return { title, firstName, lastName };
  };

  const initial = parseFullName(profile.fullName);

  const [title, setTitle] = useState(initial.title);
  const [firstName, setFirstName] = useState(initial.firstName);
  const [lastName, setLastName] = useState(initial.lastName);
  const [dob, setDob] = useState(profile.dob || "");

  const handleClear = () => {
    setFirstName("");
    setLastName("");
    setDob("");
  };

  const handleUpdate = () => {
    // TODO: yahan API call lagaiye jo updated info backend par save kare
    const updated = {
      title,
      firstName,
      lastName,
      dob,
      fullName: `${title} ${firstName} ${lastName}`.trim(),
    };
    console.log("Updating personal info:", updated);
    if (onSave) onSave(updated);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="modal-box__header">
          <h2>Update Personal Information</h2>
          <button
            type="button"
            className="modal-box__close"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="modal-box__body">
          <div className="modal-title-group">
            {["Mr.", "Ms.", "Mrs."].map((t) => (
              <button
                key={t}
                type="button"
                className={`modal-title-btn${title === t ? " active" : ""}`}
                onClick={() => setTitle(t)}
              >
                {t}
              </button>
            ))}
          </div>

          <div className="modal-field">
            <label htmlFor="firstName">First Name</label>
            <input
              id="firstName"
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>

          <div className="modal-field">
            <label htmlFor="lastName">Last Name</label>
            <input
              id="lastName"
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>

          <div className="modal-field">
            <label htmlFor="dob">Date of Birth</label>
            <input
              id="dob"
              type="date"
              placeholder="Enter Date of Birth"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-box__footer">
          <button
            type="button"
            className="modal-btn modal-btn--primary"
            onClick={handleUpdate}
          >
            UPDATE
          </button>
          <button
            type="button"
            className="modal-btn modal-btn--outline"
            onClick={handleClear}
          >
            CLEAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default function ProfilePage({ userSession }) {
  const [active, setActive] = useState("profile");
  const [bookingsOpen, setBookingsOpen] = useState(true);
  const [isEditOpen, setIsEditOpen] = useState(false);

  // Use real user data if available, fallback to demo data
  const [profile, setProfile] = useState({
    email: userSession?.UserEmail || "demo45@gmail.com",
    fullName: userSession?.UserName || "Mr Demo Test",
    mobile: userSession?.UserMobile || "9632587410",
    gstin: userSession?.GSTIN || "",
    dob: userSession?.UserDOB || "",
  });

  const handleSaveProfile = (updated) => {
    setProfile((prev) => ({
      ...prev,
      fullName: updated.fullName,
      dob: updated.dob,
    }));
    // TODO: yahan API call lagaiye jo backend me profile update kare
  };

  return (
    <div className="profile-page">
      <div className="profile-page__wrapper">
        {/* Sidebar */}
        <aside className="profile-sidebar">
          <div className="profile-sidebar__grid-icon">
            <LayoutGrid size={18} />
          </div>

          <nav className="profile-nav">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = active === item.key;
              return (
                <div key={item.key}>
                  <button
                    type="button"
                    className={`profile-nav__item${isActive ? " active" : ""}`}
                    onClick={() => {
                      setActive(item.key);
                      if (item.hasChildren) setBookingsOpen((o) => !o);
                    }}
                  >
                    <span className="profile-nav__item-left">
                      <Icon size={16} />
                      {item.label}
                    </span>
                    {item.hasChildren && (
                      <ChevronDown
                        size={16}
                        className={`profile-nav__chevron${
                          bookingsOpen ? " open" : ""
                        }`}
                      />
                    )}
                  </button>

                  {item.hasChildren && bookingsOpen && (
                    <div>
                      {item.children.map((child) => {
                        const ChildIcon = child.icon;
                        const childActive = active === child.key;
                        return (
                          <button
                            key={child.key}
                            type="button"
                            className={`profile-nav__item profile-nav__child${
                              childActive ? " active" : ""
                            }`}
                            onClick={() => setActive(child.key)}
                          >
                            <span className="profile-nav__item-left">
                              <ChildIcon size={15} />
                              {child.label}
                            </span>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </nav>
        </aside>

        {/* Main content */}
        <main className="profile-main">
          {active === "flights" ? (
            <FlightBookingsContent />
          ) : (
            <>
              <div className="profile-main__header">
                <h1>My Profile</h1>
              </div>

              <div className="profile-section">
                <h2>Login Information</h2>
                <div className="profile-field">
                  <p className="profile-field__label">Email Address</p>
                  <p className="profile-field__value">{profile.email}</p>
                </div>
              </div>

              {/* Personal Information card */}
              <div className="profile-card">
                <div className="profile-card__header">
                  <h3>Personal Information</h3>
                  <button
                    type="button"
                    className="profile-card__edit-btn"
                    onClick={() => setIsEditOpen(true)}
                  >
                    <Pencil size={12} />
                    EDIT
                  </button>
                </div>

                <div className="profile-card__body">
                  <div className="profile-field">
                    <p className="profile-field__label">Full Name</p>
                    <p className="profile-field__value">{profile.fullName}</p>
                  </div>

                  <div className="profile-field">
                    <p className="profile-field__label">Mobile No.</p>
                    <p className="profile-field__value">{profile.mobile}</p>
                  </div>
                </div>
              </div>

              {/* GSTIN Details card */}
              <div className="profile-card">
                <div className="profile-card__header">
                  <h3>GSTIN Details</h3>
                </div>
                <div className="profile-card__body">
                  <div className="profile-field">
                    <p className="profile-field__label">GSTIN Number</p>
                    <p className="profile-field__value">
                      {profile.gstin || "—"}
                    </p>
                  </div>
                </div>
              </div>
            </>
          )}
        </main>
      </div>

      {isEditOpen && (
        <EditPersonalInfoModal
          profile={profile}
          onClose={() => setIsEditOpen(false)}
          onSave={handleSaveProfile}
        />
      )}
    </div>
  );
}